import React from "react";
import R from "ramda";
import accounting from "accounting";
import classNames from "classnames";
import { withProps } from "recompose";

const Options = ({ prices, className }) => (
  <div
    className={classNames({
      "flex space-between": true,
      [className]: className,
    })}
  >
    {R.map(
      ({ length, price }) => (
        <div className="col-4 border-box py2 px1 center price">
          <p className="my0 mb1 h3 line-height-1">{length}</p>
          <p className="my0 h2 line-height-1">
            from {accounting.formatMoney(price, "€", 0)}
          </p>
        </div>
      ),
      prices
    )}
  </div>
);

//
const enhance = withProps(() => ({
  prices: [
    {
      length: "3h",
      price: 280,
    },
    {
      length: "4h",
      price: 370,
    },
    {
      length: "6h",
      price: 450,
    },
  ],
}));

export default enhance(Options);



// WEBPACK FOOTER //
// ./src/components/Options.js